<template>
  <div class="imgmodal">
    <el-carousel class="view">
      <el-carousel-item class="image" v-for="item in url" :key="item">
        <!-- {{item}} -->
        <el-image class="image" :src="item" fit="contain"></el-image>
      </el-carousel-item>
    </el-carousel>
    <!-- <el-image class="image" :src="url[0]" fit="contain"></el-image> -->
  </div>
</template>
<script>
export default {
  name: 'imgmodal',
  data() {
    return {
      url: []
    }
  },
  created() {
    this.initConnect()
  },
  mounted() {
    this.url = this.$utils.$localStorage.get("snapshotUrl")
  },
  methods: {
    initConnect() {
      const _this = this
      if (window.core) {
        const _this = this
        const connectTalkWindowUpdated = function (open) {
          _this.onHandleTalkWindowUpdated(open);
        };
        // 订阅原生事件
        window.core.talkWindowUpdated.connect(connectTalkWindowUpdated);
        this.$once("hook:beforeDestroy", () => {
          // 销毁页面后取消订阅，避免多次订阅
          window.core.talkWindowUpdated.disconnect(connectTalkWindowUpdated);
        });
      } else {
        setTimeout(() => {
          _this.initConnect()
        }, 1000)
      }
    },
    onHandleTalkWindowUpdated(open) {
      if (open) {
        this.url = this.$utils.$localStorage.get("snapshotUrl")
        // console.log(this.url, '12121212')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.imgmodal {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  padding-top: 10px;
  // background: #fff;
  background: #99a9bf;
}
.view {
  flex: 1;
  height: 100%;
}
.image {
  width: 100%;
  height: 100%;
}
.imgmodal::v-deep .el-carousel__container {
  height: 100%;
}
</style>
